import * as React from "react";
import { graphql, HeadFC, Link, StaticQuery } from "gatsby";
import "../styles/index.scss";
import Layout from "../components/layout";
import { Card, Col, Row } from "reactstrap";
import CurrentSeries from "../components/currentSeries/currentSeries";
import LandingButtons from "../components/landingButtons/landingButtons";
import Connections from "../components/connections/connections";
import LandingCards from "../components/landing-cards/landing-cards";
import ContactForm from "../components/forms/contact-form";
import { GatsbyImage } from "gatsby-plugin-image";

const IndexPage = () => {
  let churchLocation: any = {};
  let stayConnected: any[] = [];
  let nextSteps: any[] = [];
  return (
    <Layout>
      <StaticQuery
        query={SeriesQuery}
        render={(data) => {
          const {sermonTitle, sermon_series, speaker, sermonMedia, guestMinister} = data.allContentfulSermon.edges[0].node;
          const { buttons, pages, images} = data.contentfulSection;
          const sermonSeries = sermon_series[0];
          const sermonSpeaker = speaker === "Guest Minister" && guestMinister != null  ? guestMinister : speaker;
          let getInvolvedEvents = pages.find((page: any) => page.title === "Get Involved")?.eventPosts;
          let stayConnectedEvents = pages.find((page: any) => page.title === "Connect With Us")?.eventPosts;
          let nextStepEvents = pages.find((page: any) => page.title === "Next Steps")?.eventPosts;
          if (nextStepEvents !== null && nextStepEvents !== undefined){
            nextStepEvents.map((event:any) => (
              event.linkOnly = false
            ));
          }

          return (
            <>
              <Row>
                <Col md="8" className="current-series-info">
                  <CurrentSeries
                    seriesTitle={sermonSeries.seriesTitle}
                    messageTitle={sermonTitle}
                    image={sermonSeries.seriesImage.gatsbyImageData}
                    video={sermonMedia.videoLink}
                    currentMessage={sermonTitle}
                    currentSpeaker={sermonSpeaker}
                  ></CurrentSeries>
                </Col>
                <Col md="4" id="landing-button-container">
                  <LandingButtons buttons={buttons}></LandingButtons>
                </Col>
              </Row>
              {getInvolvedEvents && 
              <Row id="get-involved">
                <Col md="12">
                  <h1 className="landing-section-title">Get Involved</h1>
                  <hr className="section-title-line" />
                  <LandingCards eventPosts={getInvolvedEvents} showTitle={false}></LandingCards>
                </Col>
              </Row>}
              <Row id="connect-with-us">
                <Col md="12">
                  <h1 className="landing-section-title">Connect With Us</h1>
                  <hr className="section-title-line" />
                  {stayConnectedEvents && 
                  <LandingCards eventPosts={stayConnectedEvents} showTitle={false}></LandingCards>}
                </Col>
              </Row>
              {nextStepEvents && 
              <Row id="next-steps">                
                <Col md="12">
                  <h1 className="landing-section-title">Next Steps</h1>
                  <hr className="section-title-line" />
                  <LandingCards eventPosts={nextStepEvents} showTitle={true}></LandingCards>
                </Col>
              </Row>}
              <Row>
                <Col md="1"></Col>
                <Col md="6">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.9509585947576!2d-86.40771112465197!3d35.75201012608331!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8863fa6cc7913f1b%3A0x3c0e516903d745cb!2sImpact%20Church!5e0!3m2!1sen!2sus!4v1670719721386!5m2!1sen!2sus"
                    width="400"
                    height="300"
                    style={{ border: 0, margin: 'auto auto'}}
                    loading="lazy"
                  ></iframe>
                </Col>
                <Col md="4">
                  <ContactForm/>
                </Col>
                <Col md="2"></Col>
              </Row>
            </>
          );
        }}
      />
    </Layout>
  );
};

// Have to call All sermons in order to sort by the date field, but limit return to just one.
export const SeriesQuery = graphql`
  query {
    allContentfulSermon(
    filter: {updatedAt: {ne: "null"}}
    sort: { dateDelivered:DESC } # Sort by dateDelivered in descending order
    limit: 1 # Limit the result to only 1 item (the most recent)
    ) {
      edges {
        node {
          sermonTitle
          dateDelivered(formatString: "MMM Do, YYYY")
          speaker
          guestMinister
          sermonMedia {
            videoLink
          }
          sermon_series {
            seriesTitle
            seriesImage {
              gatsbyImageData
              description
            }
          }
        }
      }
    }
    contentfulSection(title: {eq: "Landing Page"}) {
      title
      buttons {
        title
        click
      }
      pages {
        title
        eventPosts {
          title
          fields {
            slug
          }
          displayImage {
            filename
            gatsbyImageData
          }
          pageImage {
            filename
            gatsbyImageData
          }
          details {
            raw
          }
          eventEnd
          eventStart
          externalLink {
            externalLink
          }
          internalLink 
          linkOnly
          shortDescription {
            shortDescription
            childMarkdownRemark {
              html
            }
          }
        }
        detailPosts {
          title
          shortDescription {
            shortDescription
          }
          details {
            raw
          }
        }
      }
    }
    landingJson {
      currentSeries {
        image {
          childImageSharp {
            gatsbyImageData
          }
        }
        messages {
          videoLink
          title
          speaker
          date
        }
        title
      }
    }
  }
`;

export default IndexPage;

export const Head: HeadFC = () => <title>Impact Church</title>;
